
export class SpecialInstruction {

  constructor(researchInstruction: string, admission: string, ) {
    this.researchInstruction = researchInstruction;
    this.admission = admission;
  }
  researchInstruction: string;
  admission: string;

}



// WEBPACK FOOTER //
// ./src/models/specialInstruction.ts